import React, {useContext} from "react"

export const appContext = new React.createContext(null);

export default function useApp(){
	return useContext(appContext);
}
